import styled from "styled-components";
import {colors} from "utils/colors";

export const Root = styled.div`
  width: 100%;
  height: 490px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
`

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.gray[700]};
`

export const Content = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`

export const Item = styled.div`
  width: calc(50% - 12px);
  height: 180px;
  border-radius: 16px;
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .anticon {
    align-self: flex-start;
  }

  svg {
    width: 22px;
    height: 22px;
  }

  &.products {
    background-color: rgba(0, 51, 156, 0.15);
    svg {
      fill: ${colors.primary};
    }
    .count {
      color: ${colors.primary};
    }
  }
  &.suppliers {
    background-color: rgba(255, 168, 0, 0.15);
    svg {
      fill: ${colors.warning};
    }
    .count {
      color: ${colors.warning};
    }
  }
  &.customers {
    background-color: rgba(244, 3, 3, 0.15);
    svg {
      fill: ${colors.danger};
    }
    .count {
      color: ${colors.danger};
    }
  }
  &.users {
    background-color: rgba(82, 196, 26, 0.15);
    svg {
      fill: ${colors.success};
    }
    .count {
      color: ${colors.success};
    }
  }
`

export const ItemContent = styled.div`
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 28px;
  color: ${colors.gray[900]};
  font-weight: 500 ;
  > div:last-child {
    font-size: 12px;
    font-weight: 600;
    color: ${colors.gray[500]};
  }
`
